import CqsOnlineStatoProcessoDocumentiDaFirmare from "constants/CqsOnlineStatoProcessoDocumentiDaFirmare";
import { BaseModel } from "sjs-base-model";
import CqsOnlineRichiestaDettaglioDocumentoViewModel from "./CqsOnlineRichiestaDettaglioDocumentoViewModel";
import CqsOnlineRichiestaInfoSezionePreventivoViewModel from "./CqsOnlineRichiestaInfoSezionePreventivoViewModel";

export default class CqsOnlineRichiestaSezioneDocumentiViewModel extends BaseModel {
    public readonly descrizione: string = "";
    public readonly documenti: CqsOnlineRichiestaDettaglioDocumentoViewModel[] = [];
    public readonly posizione: number = 0;
    public readonly sezioneCompletata: boolean = false;
    public readonly stato: CqsOnlineStatoProcessoDocumentiDaFirmare =
        CqsOnlineStatoProcessoDocumentiDaFirmare.DaAvviare;
    // public readonly urlFirma: string = "";
    public readonly infoSezione: CqsOnlineRichiestaInfoSezionePreventivoViewModel = new CqsOnlineRichiestaInfoSezionePreventivoViewModel(
        {}
    );

    constructor(data: Partial<CqsOnlineRichiestaSezioneDocumentiViewModel>) {
        super();

        this.update(data);
    }
}
